import { gql } from "@apollo/client";

export const SearchAssets = gql`
    query SearchAssets (
        $filter: SearchAssetFilter
        $query: SearchAssetQuery
        $pagination: Pagination
        $sort: Sort
        # SLA fields only with REACT_APP_ENABLE_SLA (older gateways reject them).
        $withSla: Boolean! = false
    ) {
        searchAssets(
            filter: $filter
            query: $query
        ) {
            total
            searchAssetResults (pagination: $pagination, sort: $sort) {
                # Flat values straight from the search index (IBM-1053) — no hop into
                # the catalog, CRM, IoT or installed base subgraphs. Everything that is
                # not in the index (contract, ancestor path, network information) comes
                # from the deferred SearchAssetsDeferred query.
                attributes {
                    assetId
                    serialNumber
                    title
                    parentNodeId
                    parentNodeTitle
                    semiconductorToolTitle
                    semiconductorChamberTitle
                    productName
                    productCode
                    manufacturerName
                    clientName
                    city
                    countryName
                    imei
                    iotConnectionStatus
                    iotHubConnectivityStatus
                    firmwareVersion
                    modemFirmwareVersion
                    iotSlaStatus @include(if: $withSla)
                    iotSlaLevel @include(if: $withSla)
                    iotConnectivityQuality @include(if: $withSla)
                }
                # Key only: row id and link target (attributes carry no asset location
                # id); resolving the key needs no subgraph hop.
                assetLocation {
                    id
                }
                metrics {
                    maintenanceDueSoon
                    maintenanceOverdue
                    maintenanceSchedule {
                        lastExhaustFilterChangeDate
                        lastMaintenanceDate
                        lastOilAndFilterChangeDate
                        lastRemanufacturingDate
                        daysUntilNextExhaustFilterChange
                        daysUntilNextOilAndFilterChange
                        daysUntilNextRemanufacturing
                        daysUntilNextService
                    }
                    harshConditionScore
                    harshConditionThreshold
                    exhaustFilterConditionScore
                    exhaustFilterConditionThreshold
                    missingSensorValues
                    lastMissingSensorValuesAt
                    sensorValueOutOfRange
                    lastSensorValueOutOfRangeAt
                    sensorValueOutOfRangeDetails {
                        telemetryParameterLabel
                        recordedSensorValue
                        recordedSensorValueUnit
                        lowerSensorThresholdValue
                        lowerSensorThresholdValueUnit
                        upperSensorThresholdValue
                        upperSensorThresholdValueUnit
                    }
                    vsdCandidateScore
                    vsdCandidateThreshold
                }
            }
        }
    }
`;
